import { render, staticRenderFns } from "./invitePaper.vue?vue&type=template&id=508e9a32&"
import script from "./invitePaper.vue?vue&type=script&lang=js&"
export * from "./invitePaper.vue?vue&type=script&lang=js&"
import style0 from "./invitePaper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports